export default "__VITE_ASSET__CwoftATp__"